"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectVehicleFormDefinition = void 0;
const FormHandlerPluginBase_1 = require("../../PluginType/FormHandler/FormHandlerPluginBase");
const FormHandlerPluginDefinition_1 = require("../../PluginType/FormHandler/FormHandlerPluginDefinition");
class SelectVehicleForm extends FormHandlerPluginBase_1.default {
    /**
     * @inheritDoc
     */
    submit(values, action = "default") {
        if (values.get('should_select_before_submit')) {
            return Promise.resolve({
                should_select_before_submit: values.get('should_select_before_submit')
            });
        }
        return Promise.resolve(0);
    }
}
exports.default = SelectVehicleForm;
exports.SelectVehicleFormDefinition = new FormHandlerPluginDefinition_1.default({
    id: "select_vehicle_form",
    class: SelectVehicleForm
});
